<template>
  <v-card class="my-4">
    <v-card-text>
      <div class="d-flex flex-column flex-sm-row">
        <v-select
          dense
          outlined
          label="Classroom"
          v-model="student.classroomId"
          :items="classrooms"
          item-value="id"
          item-text="roomNumber"
          clearable
        />
        <v-btn
          v-if="hasAdminPermission"
          @click="newClassroom"
          color="primary"
          class="ml-2"
        >
          Add Classroom
        </v-btn>
      </div>
      <div v-if="selectedClassroom" class="text-caption mx-2">
        {{ selectedClassroom.description }}
      </div>
    </v-card-text>
    <v-card-actions class="justify-space-around my-4">
      <v-btn @click="handleSubmit()" color="primary">
        {{ student.classroomId ? "Update" : "Save" }}
      </v-btn>
      <v-btn @click="cancel()">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Role } from "@/router/_helper";

export default {
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    classrooms: [],
    totalClassrooms: 0,
  }),
  mounted() {
    this.getClassrooms();
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    hasAdminPermission() {
      return (
        this.userRoles.includes(Role.ComplianceAdmin) ||
        this.userRoles.includes(Role.Admin)
      );
    },
    selectedClassroom() {
      return this.classrooms.find((c) => c.id == this.student.classroomId);
    },
  },
  methods: {
    ...mapActions("classroom", ["deleteClassroom", "fetchClassrooms"]),
    getClassrooms() {
      //default to sorting by ID desc if not defined
      const sortBy = "roomNumber";
      const sortDesc = false;
      const params = {
        page: 0,
        size: 1000,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
      };
      this.fetchClassrooms(params)
        .then((response) => {
          if (response) {
            this.totalClassrooms = response.totalElements;
            this.classrooms = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    cancel() {
      this.$emit("cancel");
    },
    newClassroom() {
      this.$router.push({ name: "classroomCreate" });
    },
    handleSubmit(){
        const classroomId = this.student.classroomId;
        const data = {
            studentId: this.student.id,
            classroomId
        }
        this.$axios.put("/student/assign-classroom", data)
            .then( () => {
                const classroom = this.classrooms.find(c => c.id == classroomId);
                this.$emit("saved", classroom);
            })
    }
  },
};
</script>

<style>
</style>